import { Persona, TipoRol } from "@rpe/registro-personas-empresas-lib";
import { Laboratorio } from "../../../actividades/entity-laboratorios/laboratorios.model";
import { Integrante } from "../../../roles/integrante/integrante.model";
import { NaturalezaJuridica } from "../../entity-naturalezas-juridica/naturalezas-juridica.model";
import { PersonasJuridica } from "../../entity-personas-juridica/entity-personas-juridica.model";
import { EntidadesProductiva } from "../../entity-entidad-productiva/entity-entidades-productiva.model";
import { EstadosRol } from "../../../roles/entity-estado-rol/entity'estados-rol.models";

export interface VistaMisIntegrantesInput {
  currentEmpresa: EntidadesProductiva
  showIntegrantes: boolean;
  integrantes: Integrante[];
  naturalezasJuridicas: NaturalezaJuridica[];
  laboratorios: Laboratorio[];
  tiposRol: TipoRol[];
  createdPersonaJuridica: PersonasJuridica;
  createdPersonaFisica: Persona | any;
  rolEstado?: EstadosRol[]
  backUrl?: string;
}

export const createVistaIntegrante = (): VistaMisIntegrantesInput => ({
  currentEmpresa: null,
  showIntegrantes: false,
  integrantes: [],
  naturalezasJuridicas: [],
  laboratorios: [],
  tiposRol: [],
  createdPersonaJuridica: null,
  createdPersonaFisica: null,
  backUrl: null,
  rolEstado: []
});
